<script>
import {
  List,
  ListItem,
  ListInput,
  AccordionContent,
  Row,
  Col,
  Segmented,
  Button,
  Link,
  Block,
  Chip,
  Preloader
} from 'framework7-svelte';
import { onMount, onDestroy } from 'svelte';
import * as moment from 'moment';
import { getExportPais,getExportEstado, getExportMunicipio,getExportAnp} from '../../tools/service/export'
import { urlServer } from '../../tools/mapboxgl/index.js'
    import { construct_svelte_component } from 'svelte/internal';

let estados=[]
let municipios=[]
let anps=[]
let pais='-1'
let estado='-1'
let municipio='-1'
let anp='-1'
let refMunicipio=''
let activateDownload=false
let downloadStatus=false
let disabledInput=false
let dateIni1=new Date();
let dateIni2=new Date();
let pickerDateIni=[moment()]
let pickerDateFin=[moment()]
let pickerDateIni2=[moment()]
let pickerDateFin2=[moment()]
let formatFile='csv'
let token=''
let statusToken=false
let statusDownload=false
let infoWarning=''

async function fileDownload(dateIni,dateFin){
	downloadStatus=true
	disabledInput=true
	let fechaIni=moment(new Date(dateIni)).format('YYYY-MM-DD')
	let fechaFin=moment(new Date(dateFin)).format('YYYY-MM-DD')
	//let url=`http://ec2-34-221-108-190.us-west-2.compute.amazonaws.com/incendios/downloads/admin`
	let url=`${urlServer}/incendios/downloads/admin`
	let formData = `fechaIni=${fechaIni.replace(/\//g,'%2F')}&fechaFin=${fechaFin.replace(/\//g,'%2F')}&pais=${pais}&estado=${estado}&municipio=${municipio}&format=${formatFile}&token=${token}`
	let contentLength = formData.length;
	console.log(url)
	const res = await fetch(url, {
		headers: {
			'Content-Length': contentLength,
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		method: 'POST',
		body: formData
	})
	const json = await res.json()
	console.log('examples getReferenceFile...',json)
	if(json['status'] && json['url']!='no.zip'){
		let a = document.querySelector(".button1")
		//a.href = `http://terra2.conabio.gob.mx/prueba_dom1/${formatFile}/${json['url']}`;
		a.href = `http://terra2.conabio.gob.mx/prueba_dom1/server_fileSATIF.php?file=${json['url']}&format=${formatFile}`;
		a.download = json['url'];
		a.click();
		downloadStatus=false
		disabledInput=false
		grecaptcha.reset(0);
		token=''
	}else{
		infoWarning=json['url']=='no.zip'?'sin puntos de calor':'error en la descarga'
		statusDownload=true
		setTimeout(()=>{statusDownload=false}, 3000);
		downloadStatus=false
		disabledInput=false
		grecaptcha.reset(0);
		token=''
	}
	downloadStatus=false
	disabledInput=false
}
async function fileDownloadANP(dateIni,dateFin){
	downloadStatus=true
	disabledInput=true
	let fechaIni=moment(new Date(dateIni)).format('YYYY-MM-DD')
	let fechaFin=moment(new Date(dateFin)).format('YYYY-MM-DD')
	//let url=`http://ec2-34-221-108-190.us-west-2.compute.amazonaws.com/incendios/downloads/anp`
	let url=`${urlServer}/incendios/downloads/anp`
	let formData = `fechaIni=${fechaIni.replace(/\//g,'%2F')}&fechaFin=${fechaFin.replace(/\//g,'%2F')}&pais=${pais}&idanp=${anp}&format=${formatFile}&token=${token}`
	let contentLength = formData.length;
	console.log(url)
	const res = await fetch(url, {
		headers: {
			'Content-Length': contentLength,
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		method: 'POST',
		body: formData
	})
	const json = await res.json()
	console.log('examples getReferenceFile...',json)
	if(json['status'] && json['url']!='no.zip'){
		grecaptcha.reset(1);
		let a = document.querySelector(".button2")
		//a.href = `http://terra2.conabio.gob.mx/prueba_dom1/${formatFile}/${json['url']}`;
		a.href = `http://terra2.conabio.gob.mx/prueba_dom1/server_fileSATIF.php?file=${json['url']}&format=${formatFile}`;
		a.download = json['url'];
		a.click();
		downloadStatus=false
		disabledInput=false
		token=''
	}else{
		grecaptcha.reset(1);
		infoWarning=json['url']=='no.zip'?'sin puntos de calor':'error en la descarga'
		statusDownload=true
		setTimeout(()=>{statusDownload=false}, 3000);
		downloadStatus=false
		disabledInput=false
		token=''
	}
	downloadStatus=false
	disabledInput=false
}
function verifyUser(e) {
	token=e
	statusToken=false
}
onMount(async () => {
	window.verifyUser = verifyUser;
});
onDestroy(() => {
	window.verifyUser = null;
})
</script>
<svelte:head>
  <script src="https://www.google.com/recaptcha/api.js?hl=es" async defer></script>
</svelte:head>
<style>
	strong {
		color: blue;
	}
	.g-recaptcha {
		transform:scale(0.79);-webkit-transform:scale(0.79);
		transform-origin: 0 0;-webkit-transform-origin: 0 0;
	}
</style>


	<List mediaList style="font-size: 93%;margin-left: 15px;">
		<ListItem title="Últimas 24 hrs." accordionItem name="demo-checkbox" >
			<AccordionContent>
				<Block>
					<Link
					href="http://terra2.conabio.gob.mx/prueba_dom1/conabio_puntos_calor.zip"
					external
					target="_blank"
					>Descargar Puntos de calor</Link>
				</Block>
			</AccordionContent>
		</ListItem>
	</List>
	<ListItem
		style="margin-left: 15px;"
		accordionItem title="Área administrativa"
		badgeColor="#007aff"
		on:accordionOpen={async ()=>{
			pais='1'
			estados = await getExportEstado({pais})
        }}
		>
		<AccordionContent>
			<ListInput
				label="Fecha de inicio:"
				type="datepicker"
				value={pickerDateIni}
				minDate={new Date('2000-01-01')}
				placeholder="Please choose..."
				resizable={true}
				calendarParams={{
				openIn:'customModal',
				header: true,
				headerPlaceholder:'seleccionar fecha...',
				footer: true,
				dateFormat: 'dd/mm/yyyy',
				toolbarCloseText:'Asignar',
				disabled: function (date) {
					if (new Date(date) <= new Date('2000-01-01')|| new Date(date) >= new Date()) {
						return true;
					}
					else {
						return false;
					}
				},
				on: {
					opened: function () {

					},
					change: function(value){
						console.log(value['value'][0])
						dateIni1=value['value'][0]
						pickerDateIni[0]=new Date(value['value'])
						pickerDateFin=[new Date(value['value'])]
						console.log('example')
					}
				}
				}}
			>
			</ListInput>
			<ListInput
				label="Fecha de término:"
				type="datepicker"
				value={pickerDateFin}
				minDate={dateIni1}
				placeholder="Please choose..."
				resizable={true}
				calendarParams={{
				openIn:'customModal',
				header: true,
				headerPlaceholder:'seleccionar fecha...',
				footer: true,
				dateFormat: 'dd/mm/yyyy',
				toolbarCloseText:'Asignar',
				disabled: function (date) {
					console.log(moment(date).local().format('YYYY-MM-DD HH:mm:ss'))
					console.log(moment(dateIni1).local().format('YYYY-MM-DD HH:mm:ss'))
					console.log(dateIni1)
					if ( date <=  dateIni1 ||  new Date(date) >= new Date()) {
						return true;
					}
					else {
						return false;
					}
				},
				on: {
					opened: function () {

					},
					change: function(value){
						pickerDateFin[0]=new Date(value['value'])
					}
				}
				}}
			>
			</ListInput>
			<ListInput
				style="margin-left: 10px;"
				label="País"
				type="select"
				bind:value={pais}
				resizable={true}
				disabled={disabledInput}
				on:change={async ()=>{
					estado = '-1'
					municipio = '-1'
					activateDownload = true
					if(pais=='1' || pais=='7'){
						refMunicipio='Municipio'
					}else if(pais=='2'){
						refMunicipio='Condado'
					}else if(pais=='3' || pais=='5' || pais=='6' || pais=='9'){
						refMunicipio='Departamento'
					}else if(pais=='4'){
						refMunicipio='Distrito'
					}else if(pais=='8'){
						refMunicipio='Provincia'
					}
					if(pais!=''){
						estados = await getExportEstado({pais})
					}
				}}
				inputStyle="text-align: center;font-size: 93%;"
				placeholder="Seleccione el País"
			>
			<div slot="item-media" style="padding-bottom: 10px;"></div>
				<option selected value="-1">Seleccione el País</option>
				<option value="1">México</option>
				<option value="2">Estados Unidos</option>
				<option value="3">Guatemala</option>
				<option value="4">Belice</option>
				<option value="5">Honduras</option>
				<option value="6">El Salvador</option>
				<option value="7">Nicaragua</option>
				<option value="8">Costa Rica</option>
				<option value="9">Panáma</option>
			</ListInput>
			{#if estados.length!=0 && pais!=''}
			<ListInput
				style="margin-left: 10px;"
				label="Estado"
				type="select"
				bind:value={estado}
				resizable={true}
				disabled={disabledInput}
				on:change={async ()=>{
					municipio = '-1'
					if(estado!=''){
						municipios = await getExportMunicipio({pais,estado})
					}
				}}
				inputStyle="text-align: center;font-size: 93%;"
				placeholder="Seleccione el Estado"
			>
			<div slot="item-media" style="padding-bottom: 10px;"></div>
				<option selected value="-1">Seleccione el Estado</option>
				{#each estados as item}
					<option value="{item['id_estado']}" >{item['nom_estado']}</option>
				{:else}
					<!-- this block renders when photos.length === 0 -->
					<option value="0" >loading...</option>
				{/each}
				<!--{#each $getPaisTot2 as {id_pais, nom_pais,total} (id_pais) }
					{#if id_pais==$paisBase2}
					<option value="{id_pais}" selected>{nom_pais}-{total}</option>
					{:else}
					<option value="{id_pais}" >{nom_pais}-{total}</option>
					{/if}
				{/each}
				-->
			</ListInput>
			{/if}
			{#if pais==1 && estados.length!=0 && municipios.length!=0 && estado!=''}
			<ListInput
				style="margin-left: 10px;"
				label="{refMunicipio}"
				type="select"
				bind:value={municipio}
				resizable={true}
				disabled={disabledInput}
				on:change={async ()=>{

				}}
				inputStyle="text-align: center;font-size: 93%;"
				placeholder="Seleccione el Municipio"
			>
			<div slot="item-media" style="padding-bottom: 10px;"></div>
				<option selected value="-1">Seleccionar {refMunicipio}</option>
				{#each municipios as item}
					<option value="{item['id_mun']}" >{item['nom_mun']}</option>
				{:else}
					<!-- this block renders when photos.length === 0 -->
					<option value="0" >loading...</option>
				{/each}
			</ListInput>
			{/if}
			{#if pais!='-1'}
				<ListInput
					label="Formato de descarga"
					type="select"
					bind:value={formatFile}
					resizable={true}
					disabled={disabledInput}
					on:change={async ()=>{

					}}
					inputStyle="text-align: center;font-size: 93%;"
					placeholder="Seleccione el Formato"
					>
					<div slot="item-media" style="padding-bottom: 10px;"></div>
					<option value="csv">Texto (delimitado por comas) (*.csv)</option>
					<option value="geojson">GeoJSON (*.geojson)</option>
					<option value="kml">Keyhole Markup Language (*.kml)</option>
					<option value="shp">ESRI Shapefile (*.shp)</option>
				</ListInput>
			{/if}
			<Row style="margin-top: 10px;">
				<Col>
					{#if statusToken}
						<Block>
							<Chip text="Seleccionar Recaptcha" color="orange" >
							</Chip>
						</Block>
					{/if}
					<!-- HTML Form -->
					<form action="/submit" method="post">
						<!-- div to show reCAPTCHA -->
						<div style="{pais!='-1'?'visibility:visible':'visibility:hidden;width: 0px;height: 0px;'} " class="g-recaptcha"
							data-sitekey="6LcuPDUeAAAAAEWmSXAyq_7LB8IyDjVTKZdqnLZE"
							data-callback="verifyUser"
							>
						</div>
					</form>
				</Col>
			</Row>
			<Row>
				<Col>
					{#if statusDownload}
						<Chip color="red" >
							<div slot="text">
								{@html infoWarning}
							</div>
						</Chip>
					{/if}
				</Col>
			</Row>
			<Row noGap>
				<Col>
				</Col>
				<Col>
					<Segmented tag="p">
						<a class="button1 link external" style="display:none;" >link descarga</a>
						{#if pais!='-1'}
							{#if !downloadStatus}
								<Button
								style="height: 24px;width: 90px;font-size: 85%;opacity:0.8;"
								on:click={()=>{
									if(token!=''){
										statusToken=false
										console.log()
										fileDownload(pickerDateIni,pickerDateFin)
									}else{
										statusToken=true
										setTimeout(()=>{statusToken=false}, 2000);
									}
								}}
								outline
								active>Descargar</Button>
							{:else}
								<Preloader></Preloader>
							{/if}
						{/if}
					</Segmented>
				</Col>
				<Col>
				</Col>
			</Row>
		</AccordionContent>
	</ListItem>
	<ListItem style="margin-left: 15px;"
		accordionItem title="Área Naturales Protegidas"
		badgeColor="#007aff"
		on:accordionOpen={async ()=>{
			pais='1'
			anps = await getExportAnp({pais})
        }}
		>
		<AccordionContent>
			<ListInput
				label="Fecha de inicio:"
				type="datepicker"
				value={pickerDateIni2}
				minDate={new Date('2000-01-01')}
				placeholder="Please choose..."
				resizable={true}
				calendarParams={{
				openIn:'customModal',
				header: true,
				headerPlaceholder:'seleccionar fecha...',
				footer: true,
				dateFormat: 'dd/mm/yyyy',
				toolbarCloseText:'Asignar',
				disabled: function (date) {
					if (date <= new Date('2000-01-01')|| date >= new Date()) {
						return true;
					}
					else {
						return false;
					}
				},
				on: {
					opened: function () {

					},
					change: function(value){
						dateIni2=new Date(value['value'])
						pickerDateIni2[0]=new Date(value['value'])
					}
				}
				}}
			>
			</ListInput>
			<ListInput
				label="Fecha de término:"
				type="datepicker"
				value={pickerDateFin2}
				minDate={new Date(2021,1,1)}
				placeholder="Please choose..."
				resizable={true}
				calendarParams={{
				openIn:'customModal',
				header: true,
				headerPlaceholder:'seleccionar fecha...',
				footer: true,
				dateFormat: 'dd/mm/yyyy',
				toolbarCloseText:'Asignar',
				disabled: function (date) {
					if (date <= dateIni2 || date >= new Date()) {
						return true;
					}
					else {
						return false;
					}
				},
				on: {
					opened: function () {

					},
					change: function(value){
						pickerDateFin2[0]=new Date(value['value'])
					}
				}
				}}
			>
			</ListInput>
			<ListInput
				style="margin-left: 10px;"
				label="País"
				type="select"
				bind:value={pais}
				resizable={true}
				disabled={disabledInput}
				on:change={async ()=>{
					activateDownload = true
					if(pais!='-1'){
						anps = await getExportAnp({pais})
					}
				}}
				inputStyle="text-align: center;font-size: 93%;"
				placeholder="Seleccione el País"
				>
				<div slot="item-media" style="padding-bottom: 10px;"></div>
				<option selected value="1">México</option>
				<option value="2">Estados Unidos</option>
				<option value="3">Guatemala</option>
				<option value="4">Belice</option>
				<option value="5">Honduras</option>
				<option value="6">El Salvador</option>
				<option value="7">Nicaragua</option>
				<option value="8">Costa Rica</option>
				<option value="9">Panáma</option>
			</ListInput>
			<ListInput
				style="margin-left: 10px;"
				label="ANP"
				type="select"
				bind:value={anp}
				resizable={true}
				disabled={disabledInput}
				on:change={async ()=>{

				}}
				inputStyle="text-align: center;font-size: 93%;"
				placeholder="Seleccionar ANP"
				>
				<div slot="item-media" style="padding-bottom: 10px;"></div>
				<option selected value="-1">Seleccionar ANP</option>
				{#each anps as item}
					<option value="{item['id']}" >{item['anp']}</option>
				{:else}
					<!-- this block renders when photos.length === 0 -->
					<option value="0" >loading...</option>
				{/each}
			</ListInput>
			{#if anp!='-1'}
				<ListInput
					label="Formato de descarga"
					type="select"
					bind:value={formatFile}
					resizable={true}
					disabled={disabledInput}
					on:change={async ()=>{

					}}
					inputStyle="text-align: center;font-size: 93%;"
					placeholder="Seleccione el Formato"
					>
					<div slot="item-media" style="padding-bottom: 10px;"></div>
					<option value="csv">Texto (delimitado por comas) (*.csv)</option>
					<option value="geojson">GeoJSON (*.geojson)</option>
					<option value="kml">Keyhole Markup Language (*.kml)</option>
					<option value="shp">ESRI Shapefile (*.shp)</option>
				</ListInput>
			{/if}
			<Row>
				<Col>
					{#if statusToken}
						<Block>
							<Chip text="Seleccionar Recaptcha" color="orange" >
							</Chip>
						</Block>
					{/if}
					<!-- HTML Form -->
					<form action="/submit" method="post">
						<!-- div to show reCAPTCHA -->
						<div style="{anp!='-1'?'visibility:visible':'visibility:hidden;width: 0px;height: 0px;'} " class="g-recaptcha"
							data-sitekey="6LcuPDUeAAAAAEWmSXAyq_7LB8IyDjVTKZdqnLZE"
							data-callback="verifyUser"
							>
						</div>
					</form>
				</Col>
			</Row>
			<Row>
				<Col>
					{#if statusDownload}
						<Chip color="red" >
							<div slot="text">
								{@html infoWarning}
							</div>
						</Chip>
					{/if}
				</Col>
			</Row>
			<Row noGap>
				<Col>
				</Col>
				<Col>
					<Segmented tag="p">
						<a class="button2 link external" style="display:none;" >link descarga</a>
						{#if anp!='-1'}
							{#if !downloadStatus}
								<Button
								style="height: 24px;width: 90px;font-size: 85%;opacity:0.8;"
								on:click={()=>{
									if(token!=''){
										statusToken=false
										fileDownloadANP(pickerDateIni2,pickerDateFin2)
									}else{
										statusToken=true
										setTimeout(()=>{statusToken=false}, 2000);
									}
								}}
								outline
								active>Descargar</Button>
							{:else}
								<Preloader></Preloader>
							{/if}
						{/if}
					</Segmented>
				</Col>
				<Col>
				</Col>
			</Row>
		</AccordionContent>
	</ListItem>
